import styled from 'styled-components'

export const Blogs = styled.div`
  /* display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 30px; */
  padding-bottom: 40px;
  .slick-slider {
    display: grid;
    max-height: 100%;
    .slick-dots {
      bottom: -25px;
    }
  }
  .slick-list, 
  .slick-track, 
  .slick-slide,
  .slick-slide > div {
    height: 100%;
  }
  .slick-slide > div {
    padding: 10px;
  }
  .slick-slide.slick-current >div  {
    padding-left: 0;
  }



/*   .slick-track {
    display: flex;
    column-gap: 16px;
    width: unset !important;
    margin: 0 -16px;
  } */
  @media screen and (min-width: 1100px) {

  }
`